module.exports = __webpack_public_path__ + "img/newscontent.12205ae9.jpg";